export const DOMAIN = 'dashboard';
